// triggers given DOM event on given node
export default function triggerOneDOMEvent(_ref) {
  var node = _ref.node,
    eventName = _ref.eventName,
    triggerArgs = _ref.triggerArgs;
  // createEvent, as IE 11 has no Event constructor
  var event = window.document.createEvent('Event');
  event.initEvent(eventName, true, true);
  // matreshkaTriggerArgs will be used in a handler created by addDOMListener
  event.matreshkaTriggerArgs = triggerArgs;
  node.dispatchEvent(event);
}